import { useSelector } from 'react-redux'

//  TODO: populate with real client IDs that are opted in to the new flow.

const CLIENT_IDS_BY_ENV: Record<string, ReadonlyArray<number>> = {
  dev: [1, 248, 414],
  staging: [1, 134, 129],
  prod: [
    1, 884, 885, 1030, 699, 710, 711, 712, 713, 714, 715, 716, 731, 732, 766,
    767, 768, 769, 770, 771, 828, 829, 832, 865, 866, 867, 869, 870, 871, 872,
    873, 874, 875, 876, 877, 878, 879, 880, 881, 888, 889, 890, 917, 942, 947,
    953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967,
    968, 969, 970, 971, 972, 973, 974, 975, 976, 1069, 1070, 1073, 1112, 1113,
    1114, 1134,1109,1110,1111
  ],
}

const getEnvKey = (): string => {
  const env = process.env.REACT_APP_B2C_ENVIRONMENTDETAILS
  return env === 'dev' || env === 'staging' ? env : 'prod'
}

export const NEW_BOOKING_FLOW_CLIENT_IDS: ReadonlySet<number> = new Set<number>(
  CLIENT_IDS_BY_ENV[getEnvKey()] ?? [],
)

export type NewBookingFlowStatus = 'enabled' | 'disabled' | 'loading'

export function useNewBookingFlowStatus(): NewBookingFlowStatus {
  const clientId = useSelector((state: any) => state?.clients?.client?.id) as
    | number
    | undefined

  if (clientId === undefined || clientId === null) {
    return 'loading'
  }

  return NEW_BOOKING_FLOW_CLIENT_IDS.has(clientId) ? 'enabled' : 'disabled'
}

export function useIsNewBookingFlowEnabled(): boolean {
  return useNewBookingFlowStatus() === 'enabled'
}
